module.exports = __webpack_public_path__ + "media/logos/law.com-logo-f1de7568.png";